/* KozyCorner — Floating Ghost product page */
(function () {
  function money(cents, fmt) {
    var n = (cents / 100).toFixed(2), parts = n.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withCommas;
      if (k === 'amount_with_comma_separator') return withCommas.replace(/,/g, '.') + ',' + parts[1];
      return withCommas + '.' + parts[1];
    });
  }
  function addBusinessDays(d, n) {
    d = new Date(d);
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function fmtDate(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }

  function init(root) {
    if (!root || root.__fg) return; root.__fg = true;
    var variants = JSON.parse((root.querySelector('[data-fg-variants]') || {}).textContent || '[]');
    var fmt = JSON.parse((root.querySelector('[data-fg-money]') || {}).textContent || '"${{amount}}"');
    var form = document.getElementById(root.getAttribute('data-form'));
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* ---------- gallery ---------- */
    var track = $('[data-fg-track]'), slides = $$('.fg-gal__slide'), thumbs = $$('.fg-gal__thumb'), idxEl = $('[data-fg-idx]');
    var cur = 0;
    function setActive(i) {
      cur = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (idxEl) idxEl.textContent = i + 1;
      var t = thumbs[i]; if (t && t.parentNode) {
        var rail = t.parentNode, r = rail.getBoundingClientRect(), tr = t.getBoundingClientRect();
        if (rail.scrollWidth > rail.clientWidth) rail.scrollLeft += (tr.left - r.left) - (r.width - tr.width) / 2;
        else if (rail.scrollHeight > rail.clientHeight) rail.scrollTop += (tr.top - r.top) - (r.height - tr.height) / 2;
      }
    }
    function go(i, instant) {
      if (!track || !slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      setActive(i);
    }
    function goMedia(id, instant) {
      for (var i = 0; i < slides.length; i++) if (String(slides[i].getAttribute('data-media')) === String(id)) return go(i, instant);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var prev = $('[data-fg-prev]'), next = $('[data-fg-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    if (track) {
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) setActive(i); }, 80);
      }, { passive: true });
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
    }
    var gal = $('[data-fg-gal]');
    if (gal && gal.getAttribute('data-start')) requestAnimationFrame(function () { goMedia(gal.getAttribute('data-start'), true); });

    /* ---------- variants ---------- */
    var idInput = form && form.querySelector('[data-fg-id]');
    var opts = $$('[data-fg-opt]');
    var nOpts = variants[0] ? variants[0].options.length : 0;
    function selected() {
      var s = [];
      for (var i = 0; i < nOpts; i++) {
        var c = root.querySelector('[data-fg-opt="' + i + '"]:checked');
        s[i] = c ? c.value : (variants[0] && variants[0].options[i]);
      }
      if (building() && charIdx > -1) s[charIdx] = slots[0];
      return s;
    }
    function find(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < sel.length; k++) if (v.options[k] !== sel[k]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function packOptIndex() {
      var el = root.querySelector('[data-units]'); return el ? +el.getAttribute('data-fg-opt') : -1;
    }
    function update(fromUser, skipImg) {
      var sel = selected(), v = find(sel), pi = packOptIndex();
      sel.forEach(function (val, i) { var l = root.querySelector('[data-fg-optlabel="' + i + '"]'); if (l && !(i === charIdx && building())) l.textContent = val; });
      var add = $('[data-fg-add]'), addLabel = $('[data-fg-addlabel]'), sAdd = $('[data-fg-stickyadd]');
      if (!v) {
        if (add) add.disabled = true; if (sAdd) sAdd.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      var p = money(v.price, fmt);
      [$('[data-fg-price]'), $('[data-fg-addprice]'), $('[data-fg-stickyprice]')].forEach(function (e) { if (e) e.textContent = p; });
      var cmp = $('[data-fg-compare]'), save = $('[data-fg-save]'), amt = $('[data-fg-saveamt]'), badge = $('[data-fg-badge]');
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = money(v.compare_at_price, fmt); }
      if (save) { save.hidden = !onSale; if (onSale && amt) amt.textContent = money(v.compare_at_price - v.price, fmt); }
      if (badge) { badge.hidden = !onSale; if (onSale) badge.textContent = '−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      if (add) add.disabled = !v.available; if (sAdd) sAdd.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? (add.getAttribute('data-label') || addLabel.textContent.replace('Sold out', 'Add to cart').replace('Unavailable', 'Add to cart')) : 'Sold out';
      var sv = $('[data-fg-stickyvar]'); if (sv) sv.textContent = building() ? (sel[pi] + ': ' + (slots.filter(Boolean).join(', ') || '…')) : v.title;
      /* pack cards: price + per-ghost for current other options */
      if (pi > -1) {
        $$('[data-units]').forEach(function (inp) {
          var s2 = sel.slice(); s2[pi] = inp.value; var pv = find(s2), u = +inp.getAttribute('data-units') || 1;
          var pe = root.querySelector('[data-fg-packprice="' + CSS.escape(inp.value) + '"]'), ee = root.querySelector('[data-fg-packeach="' + CSS.escape(inp.value) + '"]');
          if (pe) pe.textContent = pv ? money(pv.price, fmt) : '—';
          if (ee) ee.textContent = pv ? (u > 1 ? money(Math.floor(pv.price / u), fmt) + ' per ghost' : 'Just one') : '';
        });
      }
      /* image */
      if (v.featured_media && fromUser && !skipImg) goMedia(v.featured_media.id);
      var sp = $('[data-fg-stickypic]');
      if (sp && v.featured_image) sp.innerHTML = '<img src="' + v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="60" height="60">';
      if (fromUser && window.history && history.replaceState) {
        var u2 = new URL(location.href); u2.searchParams.set('variant', v.id); history.replaceState(null, '', u2.toString());
      }
      gate(); nudge();
    }
    var addBtn = $('[data-fg-add]'), lbl = $('[data-fg-addlabel]');
    if (addBtn && lbl && lbl.textContent.trim() !== 'Sold out') addBtn.setAttribute('data-label', lbl.textContent.trim());
    /* ---------- mix & match pack builder ---------- */
    var charSet = $('[data-fg-imgopt]'), charIdx = charSet ? +charSet.getAttribute('data-fg-imgopt') : -1;
    var build = $('[data-fg-build]'), slotsEl = $('[data-fg-slots]'), props = form && form.querySelector('[data-fg-props]');
    var legendName = $('[data-fg-legendname]'), propLabel = (build && build.getAttribute('data-prop')) || 'Ghost';
    var progressEl = $('[data-fg-progress]'), saveEl = $('[data-fg-buildsave]'), nudgeEl = $('[data-fg-nudge]');
    var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var slots = [], active = 0;
    var charNames = $$('[data-fg-opt="' + charIdx + '"]').map(function (i) { return i.value; });
    function units() { var c = root.querySelector('[data-units]:checked'); return c ? (+c.getAttribute('data-units') || 1) : 1; }
    function building() { return charIdx > -1 && !!build && units() > 1; }
    function missing() { return building() ? slots.filter(function (x) { return !x; }).length : 0; }
    function charValue() { var c = root.querySelector('[data-fg-opt="' + charIdx + '"]:checked'); return c ? c.value : ''; }
    function tileInput(name) { return root.querySelector('[data-fg-opt="' + charIdx + '"][value="' + CSS.escape(name || '') + '"]'); }
    function tileImg(name) { var inp = tileInput(name), img = inp && inp.parentNode.querySelector('img'); return img ? (img.currentSrc || img.src) : ''; }
    function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
    function plural(n) { return n + ' ' + propLabel.toLowerCase() + (n === 1 ? '' : 's'); }
    function syncTile() { var inp = tileInput(slots[active] || ''); if (inp) inp.checked = true; else $$('[data-fg-opt="' + charIdx + '"]').forEach(function (i) { i.checked = false; }); }
    function goChar(name) {
      for (var i = 0; i < variants.length; i++) if (variants[i].options[charIdx] === name && variants[i].featured_media) return goMedia(variants[i].featured_media.id);
    }
    function nextEmpty(from) { for (var k = 1; k <= slots.length; k++) { var j = (from + k) % slots.length; if (!slots[j]) return j; } return -1; }
    function packValues() { return $$('[data-units]').map(function (i) { return { el: i, value: i.value, units: +i.getAttribute('data-units') || 1 }; }); }
    function priceFor(packValue) {
      var s = selected(); var pi = packOptIndex(); if (pi < 0) return null; s[pi] = packValue; var v = find(s); return v ? v.price : null;
    }
    function singlePrice() { var pv = packValues(); return pv.length ? priceFor(pv[0].value) : null; }
    function renderSlots(popIdx) {
      var on = building();
      if (build) build.hidden = !on;
      $$('.fg-pick-img__item').forEach(function (it) { var b = it.querySelector('.fg-tile-count'); if (b) b.remove(); it.classList.remove('in-pack'); });
      if (!on) {
        if (props) props.innerHTML = '';
        if (legendName) legendName.textContent = legendName.getAttribute('data-default');
        var l0 = root.querySelector('[data-fg-optlabel="' + charIdx + '"]'); if (l0) l0.textContent = charValue();
        return;
      }
      slotsEl.style.setProperty('--n', slots.length);
      slotsEl.innerHTML = slots.map(function (n, i) {
        var src = n ? tileImg(n) : '';
        return '<button type="button" class="fg-slot' + (i === active ? ' is-active' : '') + (n ? '' : ' is-empty') + (i === popIdx ? ' is-pop' : '') + '" data-slot="' + i + '" aria-pressed="' + (i === active) + '">' +
          '<span class="fg-slot__pic">' + (src ? '<img src="' + src + '" alt="">' : '<i aria-hidden="true">+</i>') + '</span>' +
          '<span class="fg-slot__txt"><small>' + esc(propLabel) + ' ' + (i + 1) + '</small><b>' + (n ? esc(n) : 'Tap a ghost') + '</b></span></button>';
      }).join('');
      if (props) props.innerHTML = slots.map(function (n, i) {
        return n ? '<input type="hidden" name="properties[' + esc(propLabel) + ' ' + (i + 1) + ']" value="' + esc(n) + '">' : '';
      }).join('');
      var filled = slots.length - missing();
      if (progressEl) progressEl.innerHTML = '<b>' + filled + '</b> of ' + slots.length + ' picked' + (filled === slots.length ? ' <span class="fg-ok">✓</span>' : '');
      if (legendName) legendName.textContent = filled === slots.length ? 'Your pack' : 'Pick ' + propLabel.toLowerCase() + ' ' + (active + 1) + ' of ' + slots.length;
      var l = root.querySelector('[data-fg-optlabel="' + charIdx + '"]'); if (l) l.textContent = filled === slots.length ? plural(slots.length) + ' ready' : (slots[active] || 'tap a character below');
      /* count badges on tiles */
      var counts = {}; slots.forEach(function (n) { if (n) counts[n] = (counts[n] || 0) + 1; });
      Object.keys(counts).forEach(function (n) {
        var inp = tileInput(n); if (!inp) return; var it = inp.parentNode; it.classList.add('in-pack');
        var pic = it.querySelector('.fg-pick-img__pic'); var b = document.createElement('span'); b.className = 'fg-tile-count'; b.textContent = '×' + counts[n]; pic.appendChild(b);
      });
      /* savings */
      var sp = singlePrice(), pp = priceFor((root.querySelector('[data-units]:checked') || {}).value);
      if (saveEl) saveEl.textContent = (sp && pp && sp * slots.length > pp) ? 'You save ' + money(sp * slots.length - pp, fmt) + ' vs buying ' + slots.length + ' separately.' : '';
    }
    function gate() {
      var add = $('[data-fg-add]'), addLabel = $('[data-fg-addlabel]'), sAdd = $('[data-fg-stickyadd]');
      if (!add || !addLabel || !sAdd) return;
      var base = add.getAttribute('data-label') || 'Add to cart';
      if (!sAdd.getAttribute('data-label')) sAdd.setAttribute('data-label', sAdd.textContent.trim());
      var m = missing(), sel = find(selected());
      if (sel && !sel.available) return;
      if (m > 0) {
        add.disabled = true; sAdd.disabled = true; add.classList.add('is-waiting');
        addLabel.textContent = 'Pick ' + m + ' more ' + propLabel.toLowerCase() + (m === 1 ? '' : 's'); sAdd.textContent = addLabel.textContent;
      } else {
        add.disabled = false; sAdd.disabled = false; add.classList.remove('is-waiting');
        addLabel.textContent = building() ? 'Add ' + plural(slots.length) + (window.innerWidth > 520 ? ' to cart' : '') : base; sAdd.textContent = building() ? 'Add ' + plural(slots.length) : sAdd.getAttribute('data-label');
      }
    }
    function nudge() {
      if (!nudgeEl) return;
      var pv = packValues(), cur = -1;
      pv.forEach(function (p, i) { if (p.el.checked) cur = i; });
      var nx = pv[cur + 1], sp = singlePrice();
      if (cur < 0 || !nx || !sp) { nudgeEl.hidden = true; return; }
      var curPrice = priceFor(pv[cur].value), nxPrice = priceFor(nx.value);
      if (!curPrice || !nxPrice) { nudgeEl.hidden = true; return; }
      var extra = nx.units - pv[cur].units, saving = sp * nx.units - nxPrice;
      nudgeEl.innerHTML = '<span aria-hidden="true">👻</span> Add ' + plural(extra) + ' for just <b>' + money(nxPrice - curPrice, fmt) + '</b> more' + (saving > 0 ? ' and save <b>' + money(saving, fmt) + '</b>' : '') + ' <i aria-hidden="true">→</i>';
      nudgeEl.setAttribute('data-target', nx.value); nudgeEl.hidden = false;
    }
    if (nudgeEl) nudgeEl.addEventListener('click', function () {
      var t = root.querySelector('[data-units][value="' + CSS.escape(nudgeEl.getAttribute('data-target') || '') + '"]');
      if (t) { t.checked = true; t.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    function fly(name, toIdx) {
      if (reduceMotion || !slotsEl) return;
      var inp = tileInput(name), img = inp && inp.parentNode.querySelector('img'), slot = slotsEl.querySelector('[data-slot="' + toIdx + '"] .fg-slot__pic');
      if (!img || !slot || !img.animate) return;
      var a = img.getBoundingClientRect(), b = slot.getBoundingClientRect(), c = img.cloneNode();
      c.className = 'fg-flyer'; c.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px';
      document.body.appendChild(c);
      var dx = b.left - a.left + (b.width - a.width) / 2, dy = b.top - a.top + (b.height - a.height) / 2, s = b.width / a.width;
      c.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + dx * .5 + 'px,' + (dy * .5 - 60) + 'px) scale(' + (1 + s) / 2 + ') rotate(-8deg)', opacity: 1 }, { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')', opacity: .2 }], { duration: 650, easing: 'cubic-bezier(.3,.7,.2,1)' }).onfinish = function () { c.remove(); };
    }
    function celebrate() {
      if (reduceMotion || !slotsEl) return;
      var r = slotsEl.getBoundingClientRect();
      for (var i = 0; i < 9; i++) {
        var g = document.createElement('span'); g.className = 'fg-boo';
        g.style.left = (r.left + r.width * Math.random()) + 'px'; g.style.top = (r.top + r.height * .4) + 'px';
        document.body.appendChild(g);
        g.animate([{ transform: 'translate(0,0) scale(.4)', opacity: 0 }, { opacity: 1, offset: .2 }, { transform: 'translate(' + (Math.random() * 80 - 40) + 'px,' + (-70 - Math.random() * 70) + 'px) scale(1)', opacity: 0 }], { duration: 1100 + Math.random() * 500, delay: i * 50, easing: 'ease-out' }).onfinish = (function (el) { return function () { el.remove(); }; })(g);
      }
    }
    if (slotsEl) slotsEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-slot]'); if (!b) return;
      active = +b.getAttribute('data-slot'); syncTile(); renderSlots(); if (slots[active]) goChar(slots[active]);
    });
    var sameBtn = $('[data-fg-same]'), rndBtn = $('[data-fg-random]');
    if (sameBtn) sameBtn.addEventListener('click', function () {
      var n = slots[active] || slots[0]; var wasMissing = missing();
      slots = slots.map(function () { return n; }); renderSlots(); if (wasMissing) celebrate(); update(true, true);
    });
    if (rndBtn) rndBtn.addEventListener('click', function () {
      var pool = charNames.slice(), wasMissing = missing();
      slots = slots.map(function () { if (!pool.length) pool = charNames.slice(); return pool.splice(Math.floor(Math.random() * pool.length), 1)[0]; });
      active = 0; syncTile(); renderSlots(); goChar(slots[0]); celebrate(); update(true, true);
    });
    function onPack() {
      var u = units(), base = slots[0] || charValue();
      if (u > 1 && charIdx > -1) {
        var next = []; for (var i = 0; i < u; i++) next[i] = slots[i] || (i === 0 ? base : '');
        slots = next; var e = nextEmpty(-1 + 0); active = e > -1 ? e : 0;
        syncTile();
      } else if (slots.length) {
        var keep = slots[0]; slots = []; active = 0;
        var inp = tileInput(keep); if (inp) inp.checked = true;
      }
      renderSlots(); update(true);
    }
    function onChar() {
      if (building()) {
        var val = charValue(), filled = active, wasMissing = missing();
        slots[active] = val;
        var e = nextEmpty(active);
        active = e > -1 ? e : (active + 1) % slots.length;
        syncTile(); renderSlots(filled); fly(val, filled); goChar(val);
        if (wasMissing && !missing()) celebrate();
        update(true, true);
      } else update(true);
    }
    opts.forEach(function (o) {
      o.addEventListener('change', function () {
        if (o.hasAttribute('data-units')) onPack();
        else if (+o.getAttribute('data-fg-opt') === charIdx) onChar();
        else update(true);
      });
    });
    if (units() > 1 && charIdx > -1) { slots = []; onPack(); } else update(false);

    /* ---------- quantity ---------- */
    var q = $('[data-fg-qtyinput]');
    $$('[data-fg-qty]').forEach(function (b) {
      b.addEventListener('click', function () { if (!q) return; var n = Math.min(20, Math.max(1, (+q.value || 1) + (+b.getAttribute('data-fg-qty')))); q.value = n; });
    });

    /* ---------- delivery estimate ---------- */
    var ship = $('[data-fg-ship]');
    if (ship) {
      var now = new Date(), mn = +ship.getAttribute('data-min') || 4, mx = +ship.getAttribute('data-max') || 10;
      var a = addBusinessDays(now, mn), b = addBusinessDays(now, mx), eta = $('[data-fg-eta]');
      if (eta) eta.textContent = fmtDate(a) + ' – ' + fmtDate(b);
      var w = (ship.getAttribute('data-warn') || '').split('-'), warn = $('[data-fg-warn]');
      if (warn && w.length === 2) {
        var wd = new Date(now.getFullYear(), +w[0] - 1, +w[1], 23, 59);
        if (now <= wd && b > wd) warn.hidden = false;
      }
    }

    /* ---------- sticky bar ---------- */
    var sticky = $('[data-fg-sticky]'), anchor = $('.fg-buy__row');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0], above = e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', !e.isIntersecting && above);
      }).observe(anchor);
    }
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-fg-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
